import React, { useEffect, useState } from "react";
import { api } from "../../api/client";
import { Paper, Typography, Box, CircularProgress } from "@material-ui/core";
import { useParams } from "react-router-dom";
import Documents from "../../components/contractor/Documents";
import Layout from "../../components/layout/Layout";
import { toFarsiDigits } from "../../assets/utils";

/**
 * صفحهٔ «اسناد قرارداد» برای ناظر — اسنادِ حسابداریِ همان قرارداد.
 * (شناسهٔ قرارداد از مسیرِ صفحه می‌آید: /supervisor/contracts/:contractId/documents)
 */
export default function SupervisorDocumentsPage() {
  const { contractId } = useParams();
  const [contract, setContract] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [documentTransfers, setDocumentTransfers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!contractId) return undefined;
    let alive = true;
    const run = async () => {
      try {
        setLoading(true);
        setErr("");
        // ۱) خودِ قرارداد (برای عنوان و فیلترها)
        const res = await api.get("contracts/", { params: { page: 1, page_size: 300 } });
        const rows = res.data.results || res.data || [];
        const c = rows.find((r) => String(r.id) === String(contractId));
        if (!alive) return;
        if (!c) {
          setErr("این قرارداد در دسترسِ شما نیست.");
          setLoading(false);
          return;
        }
        setContract(c);
        // ۲) اسنادِ حسابداریِ قرارداد + انتقالِ اسناد
        const [docsRes, trRes] = await Promise.all([
          api.get(`contracts/${contractId}/documents/`),
          api.get(`contracts/documents/document_transfer/contract/${contractId}/`),
        ]);
        if (!alive) return;
        const pick = (r) => (r && r.data && r.data.results ? r.data.results : (r && r.data) || []);
        setDocuments(pick(docsRes) || []);
        setDocumentTransfers(pick(trRes) || []);
      } catch (e) {
        if (alive) setErr("خطا در دریافت اسناد قرارداد");
      } finally {
        if (alive) setLoading(false);
      }
    };
    run();
    return () => { alive = false; };
  }, [contractId]);

  return (
    <Layout>
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6" align="center" gutterBottom>
        اسناد حسابداری قرارداد
        {contract && contract.number ? ` ${toFarsiDigits(contract.number)}` : ""}
      </Typography>

      {loading && (
        <Box display="flex" justifyContent="center" style={{ padding: 20 }}>
          <CircularProgress size={26} />
        </Box>
      )}

      {err && (
        <Typography align="center" style={{ color: "#c62828" }}>
          {err}
        </Typography>
      )}

      {contract && !loading && (
        <Documents
          contract={contract}
          documents={documents}
          documentTransfers={documentTransfers}
        />
      )}
    </Paper>
    </Layout>
  );
}
